if (!customElements.get('product-card-swatches')) {
  customElements.define(
    'product-card-swatches',
    class ProductCardSwatches extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', this.onSwatchClick.bind(this));
        this.addEventListener('pointerenter', this.onSwatchHover.bind(this), true);
      }

      onSwatchHover(event) {
        const button = event.target.closest('.goshop-product-card-swatch');
        if (!button || !this.contains(button)) return;

        // These full-size photos can be a few hundred KB straight from the
        // CDN; warm the browser cache on hover so the click-driven swap
        // (below) doesn't sit on a blank/stale image while it downloads.
        const src = button.getAttribute('data-swatch-image');
        if (src && !button.dataset.preloaded) {
          button.dataset.preloaded = 'true';
          new Image().src = src;
        }
      }

      onSwatchClick(event) {
        const button = event.target.closest('.goshop-product-card-swatch');
        if (!button || !this.contains(button)) return;

        event.preventDefault();

        const newSrc = button.getAttribute('data-swatch-image');
        const newSrcset = button.getAttribute('data-swatch-srcset');

        if (newSrc) {
          const wrapper = this.closest('.goshop-product-card-wrapper');
          const image = wrapper && wrapper.querySelector('.goshop-product-card-image:not(.goshop-product-card-image--secondary)');
          if (image) {
            image.src = newSrc;
            image.setAttribute('data-src', newSrc);
            if (newSrcset) {
              image.srcset = newSrcset;
              image.setAttribute('data-srcset', newSrcset);
            }
          }
          // The card's hover effect fades this image out in favor of a
          // secondary photo, which would hide the color we just switched
          // to whenever the pointer is over the swatch row. Pin it visible.
          if (wrapper) wrapper.classList.add('has-selected-color');
        }

        this.querySelectorAll('.goshop-product-card-swatch').forEach((swatchButton) => {
          const isSelected = swatchButton === button;
          swatchButton.classList.toggle('is-selected', isSelected);
          swatchButton.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
        });
      }
    }
  );
}
